const variant = process.env.REACT_APP_PRODUCT_VARIANT ?? "default";

async function load(moduleName) {
	const loadVariant = async variant =>
		import(`./${variant}/${moduleName}`).then(module => {
			console.log(`Loaded "${variant}" variant of ${moduleName}`);
			return module;
		});

	return loadVariant(variant)
		.catch(() => loadVariant("default"))
		.then(module => (typeof module.default == "object" ? module.default : new module.default()));
}

export let Messages;
export let Recommendations;
export let MaterialInfo;
export let FieldsNaming;
export let ExtendedWhereUsedFactors;
export let Archive;
export let Scenarios;
export let StockingCalculator;
export let Logo;

export async function loadVariants() {
	Messages = await load("messages.json");
	Recommendations = await load("Recommendations");
	MaterialInfo = await load("MaterialInfo");
	FieldsNaming = await load("FieldsNaming");
	ExtendedWhereUsedFactors = await load("ExtendedWhereUsedFactors");
	Archive = await load("Archive");
	Scenarios = await load("Scenarios");
	StockingCalculator = await load("StockingCalculator");
	Logo = await load("Logo");
}
